"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var Tab_1 = __importDefault(require("@mui/material/Tab"));
var omit_1 = __importDefault(require("lodash/omit"));
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var general_1 = require("utils/general");
var TabsContainer_1 = __importDefault(require("./TabsContainer"));
// Declaring type for Navtab as material ui does not understand passing in "component" to Tab as a valid prop :/
var NavTab = (0, styles_1.styled)(Tab_1.default, { shouldForwardProp: (0, general_1.omitProps)('iconColor', 'inactive') })(function (_a) {
    var iconColor = _a.iconColor, inactive = _a.inactive;
    return (__assign({ '&.active svg, :hover svg': { color: iconColor } }, inactive && { '&.active span': { color: '#83949C', borderBottomColor: 'transparent', textShadow: 'none' } }));
});
// ToDo: evaluate switching the implementation of tabs away from Mui-Tabs
var NavTabs = function (_a) {
    var tabs = _a.tabs, onClick = _a.onClick, rest = __rest(_a, ["tabs", "onClick"]);
    var location = (0, react_router_1.useLocation)();
    var val = react_1.default.useMemo(function () { return tabs.findIndex(function (tab) { return tab.href === location.pathname; }); }, [location.pathname]);
    return ((0, jsx_runtime_1.jsx)(TabsContainer_1.default, __assign({ value: val }, { children: tabs.map(function (tab, idx) { return ((0, jsx_runtime_1.jsx)(NavTab, __assign({}, (0, omit_1.default)(rest, 'children'), { component: react_router_dom_1.NavLink, iconColor: tab.iconColor, exact: true, label: !tab.icon
                ? (0, jsx_runtime_1.jsx)("span", { children: tab.label })
                : (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "inline-flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: tab.icon }), " ", (0, jsx_runtime_1.jsx)("span", { children: tab.label })] })), to: tab.href || '#', onClick: onClick, inactive: !tab.href, tabIndex: idx }), tab.label)); }) })));
};
exports.default = react_1.default.memo(NavTabs);
